export const allowedEmails = ['santi@gmail.com', 'santi.gomez5@gmail.com', 'javi@gmail.com'];

export const isAllowedUser = (email: string) => {
  return email ? allowedEmails.includes(email.toLowerCase()) : false;
}